import React, { useState } from "react";

export default function JuniorCoach() {
  const [activeImg, setActiveImg] = useState(null);
  return (
    <section
      id="junior-coach"
      data-testid="junior-coach-section"
      className="relative py-24 md:py-32 bg-[#0a0a0a] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Copy LEFT — flipped layout vs head coach for hierarchy */}
          <div className="lg:col-span-7 order-2 lg:order-1">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#d4af37]" />
              <span className="text-xs uppercase tracking-[0.3em] text-[#d4af37] font-bold">
                Junior Coach
              </span>
            </div>

            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.9]">
              Memoe <br />
              <span className="text-[#d4af37]">Jarallah.</span>
            </h2>

            <p className="mt-3 text-sm uppercase tracking-[0.25em] text-white/50">
              26 · Active Competitor · 14+ Yrs On The Mat
            </p>

            <div className="mt-7 space-y-4 text-white/75 text-base leading-relaxed max-w-2xl">
              <p>
                Memoe started training at 12 and stepped onto the competition mat
                at 13. The years on the mat since have built the foundation he
                still works on every session. Today he balances active competition
                with coaching, learning his craft under the watchful eye of his
                coach and mentor, Russell Thompson.
              </p>
              <p>
                A black belt in Okinawan Karate with ranks in Muay Thai and
                Kempo Jiu-Jitsu, plus a decade of boxing study, Memoe brings a
                hybrid style rooted in traditional fundamentals. His students
                get clear communication, structured progression, and
                competition-tested instruction.
              </p>
            </div>
          </div>

          {/* Portrait RIGHT — two-photo stack, greyscale interactive */}
          <div className="lg:col-span-5 order-1 lg:order-2">
            <div className="relative w-full max-w-md ml-auto space-y-3">
              {[
                {
                  src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_fullcircle-mma/artifacts/fvqk9i9o_WOLLONGONG%20WARS%2027%20JUN%2026-653.webp",
                  ratio: "aspect-[4/3]",
                  alt: "Memoe Jarallah with his corner after taking the win at Wollongong Wars",
                  badge: "Full Circle Corner",
                },
              ].map((img, i) => {
                const isActive = activeImg === i;
                return (
                <button
                  type="button"
                  key={i}
                  onClick={() => setActiveImg(isActive ? null : i)}
                  className={`block group relative ${img.ratio} w-full overflow-hidden focus:outline-none focus:ring-2 focus:ring-[#d4af37]`}
                  aria-label={isActive ? "Show greyscale" : "Show in colour"}
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    className={`absolute inset-0 w-full h-full object-cover transition-all duration-700 ${
                      isActive ? "grayscale-0 scale-105" : "grayscale group-hover:grayscale-0 group-hover:scale-105"
                    }`}
                    style={{ filter: "contrast(1.08) saturate(1.1)" }}
                  />
                  <div className="pointer-events-none absolute inset-0 ring-1 ring-[#d4af37]/30" />
                  <div className="absolute top-3 left-3 bg-[#d4af37] text-black px-3 py-1.5 font-heading uppercase text-[11px] tracking-[0.25em] shadow-[0_8px_24px_-8px_rgba(212,175,55,0.6)]">
                    Coach Memoe
                  </div>
                  <div className="absolute top-3 right-3 bg-black/70 backdrop-blur-sm border border-white/20 px-3 py-1.5 text-[10px] uppercase tracking-[0.25em] text-white/80">
                    {img.badge}
                  </div>
                </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
